var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9997,
    cy: 15.9997,
    r: 14.6667,
    fill: "#6568E6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6667,
    cy: 14.6667,
    r: 5.66667,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7071 19.2939L20 18.5868L18.5858 20.001L19.2929 20.7081L20.7071 19.2939ZM22.2929 23.7081C22.6834 24.0986 23.3166 24.0986 23.7071 23.7081C24.0976 23.3176 24.0976 22.6844 23.7071 22.2939L22.2929 23.7081ZM19.2929 20.7081L22.2929 23.7081L23.7071 22.2939L20.7071 19.2939L19.2929 20.7081Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon2);
export default __webpack_public_path__ + "static/media/search_icon2.a4343a6f664ca9c3231448584e3479f3.svg";
export { ForwardRef as ReactComponent };